import styled, { StyledComponent } from 'styled-components';

export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
`;

export const BulkActionWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 20px;
`;

export const SeparatorWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  padding: 2px 8px;
`;

export const Line: StyledComponent<'div', any> = styled.div`
  width: 1px;
  flex: 1;

  background: #d9d9d9;
`;

export const TableTitleWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  padding: 14px 8px 8px;
  align-items: flex-start;
  gap: 12px;

  color: rgba(0, 0, 0, 0.88);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
`;

export const NameList: StyledComponent<'div', any> = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NameItem: StyledComponent<'div', any> = styled.div`
  display: flex;
  gap: 8px;

  color: rgba(0, 0, 0, 0.88);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 20px;
`;

export const RequestCompletionPromptWrapper: StyledComponent<'div', any> = styled.div`
  padding: 8px 24px 48px 24px;
`;

export const RequestCompletionPromptContent: StyledComponent<'div', any> = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  background: #f6ffed;
`;
